"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamMedalOverview = void 0;
const react_1 = __importStar(require("react"));
const PlayerMedalsCard_1 = require("../molecules/PlayerMedalsCard");
const Modal_1 = require("lincd-mui-base/lib/components/Modal");
const PlayerScoreOverview_1 = require("./PlayerScoreOverview");
require("./TeamMedalOverview.scss");
const TeamMedalOverview_scss_json_1 = __importDefault(require("./TeamMedalOverview.scss.json"));
const react_2 = require("@tolgee/react");
const TeamMedalOverview = ({ members }) => {
    let { t } = (0, react_2.useTranslate)();
    const prefix = 'medalOverview';
    const [selectedMember, setSelectedMember] = (0, react_1.useState)();
    const selectMember = (member) => {
        setSelectedMember(member);
    };
    return (react_1.default.createElement("div", { className: TeamMedalOverview_scss_json_1.default.TeamMedalOverview },
        react_1.default.createElement("div", { className: TeamMedalOverview_scss_json_1.default.Header },
            react_1.default.createElement("h2", { className: TeamMedalOverview_scss_json_1.default.Title }, t(prefix + '.teammates', 'Teammates'))),
        react_1.default.createElement("div", { className: TeamMedalOverview_scss_json_1.default.Content },
            members.size > 0 &&
                members.map((teamMember) => (react_1.default.createElement(PlayerMedalsCard_1.PlayerMedalsCard, { of: teamMember, onClick: () => selectMember(teamMember), key: teamMember.uri, className: TeamMedalOverview_scss_json_1.default.PlayerMedalsCard }))),
            selectedMember && (react_1.default.createElement(Modal_1.Modal, { isOpen: selectedMember && true, onClose: () => setSelectedMember(null), renderContent: react_1.default.createElement(PlayerScoreOverview_1.PlayerScoreOverview, { of: selectedMember }) })))));
};
exports.TeamMedalOverview = TeamMedalOverview;
//# sourceMappingURL=TeamMedalOverview.js.map